import React from 'react';
import { RuleDot } from './Decor';
import { SECTION_IDS } from '../utils/scroll';
const stages = [{
  number: '01',
  stage: 'Crear',
  claim: 'Necesito formalizar mi negocio.',
  body: 'Para quienes tienen una idea o están listos para crear su empresa en Florida.'
}, {
  number: '02',
  stage: 'Construir',
  claim: 'Ya tengo mi empresa y necesito presencia profesional.',
  body: 'Para negocios que necesitan identidad, web y una presencia digital profesional.'
}, {
  number: '03',
  stage: 'Crecer',
  claim: 'Quiero una estructura completa para desarrollar mi negocio.',
  body: 'Para quienes quieren integrar creación, estructura y presencia profesional.'
}];
export function Process() {
  return <section id={SECTION_IDS.proceso} aria-labelledby="proceso-titulo" className="relative scroll-mt-24 bg-gradient-to-b from-lavender-50 to-ivory sm:scroll-mt-28" data-id="element-211" data-mp="1kgqof3z6otin">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-16 lg:py-24" data-id="element-212" data-mp="rxk0lf33ywo4">
        <RuleDot data-id="element-213" data-mp="19jxuthu9jid2" />
        <h2 id="proceso-titulo" className="mt-5 max-w-2xl font-display text-[1.7rem] leading-[1.16] text-plum-900 sm:text-4xl lg:text-[2.6rem]" data-id="element-214" data-mp="19kfygzj98yv0">
          ¿En qué etapa está tu negocio?
        </h2>

        <div className="relative mt-8 sm:mt-12" data-id="element-215" data-mp="vtuet8lz8kw2">
          {/* Progresión: Crear → Construir → Crecer */}
          <div aria-hidden="true" className="absolute left-[0.4rem] top-2 hidden h-[calc(100%-1rem)] w-px bg-gradient-to-b from-lavender-300 via-lavender-200 to-transparent sm:left-0 sm:top-[0.4rem] sm:h-px sm:w-full sm:bg-gradient-to-r" data-id="element-216" data-mp="quhscoz0pfu0" />

          <ol className="grid gap-7 sm:grid-cols-3 sm:gap-8 lg:gap-12" data-id="element-217" data-mp="hw5v443nbjsl">
            {stages.map(item => <li key={item.number} className="group relative pl-8 sm:pl-0 sm:pt-8" data-id="element-218" data-mp="cxb96tadtf49">
                <span aria-hidden="true" className="absolute left-0 top-1.5 h-3 w-3 rounded-full border-2 border-lavender-300 bg-ivory transition-[background-color,border-color,transform] duration-200 ease-premium group-hover:scale-110 group-hover:border-plum-700 group-hover:bg-lavender-100 sm:top-0" data-id="element-219" data-mp="2c5zz9ksblamm" />
                <div className="flex items-baseline gap-3.5" data-id="element-220" data-mp="2hdzgur4vywzm">
                  <span className="font-display text-[2.5rem] leading-none text-lavender-300 transition-colors duration-200 ease-premium group-hover:text-orchid sm:text-5xl lg:text-6xl" data-id="element-221" data-mp="2mc10pea4z0c5">
                    {item.number}
                  </span>
                  <h3 className="eyebrow text-plum-700" data-id="element-222" data-mp="3e1w0y5zj8afl">{item.stage}</h3>
                </div>
                <p className="mt-3.5 max-w-xs font-display text-[1.05rem] leading-snug text-plum-900 sm:mt-5 sm:text-[1.15rem]" data-id="element-223" data-mp="302cv5ju71b6g">
                  {item.claim}
                </p>
                <p className="mt-2 max-w-xs text-[0.925rem] leading-relaxed text-muted sm:mt-2.5" data-id="element-224" data-mp="1onpq9gwdhywv">
                  {item.body}
                </p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}